// import utils
import { createTheme } from "@mui/material/styles";
import { MUI_X_LICENSE } from "./mui.license.js";
// import config
import { LicenseInfo } from "@mui/x-license";
import components from "./theme-options/components/index.js";
import typography from "./theme-options/typography/index.js";
import colorSchemes from "./theme-options/palette/index.js";
import breakpoints from "./theme-options/breakpoints/index.js";
LicenseInfo.setLicenseKey(MUI_X_LICENSE);
export const muiThemeOptions = {
    cssVariables: {
        colorSchemeSelector: "class",
    },
    defaultColorScheme: "light",
    colorSchemes,
    typography,
    components,
    breakpoints,
    spacing: 4,
    shape: {
        borderRadius: 16,
    },
    mixins: {
        toolbar: {
            minHeight: "56px",
        },
    },
};
export const muiTheme = createTheme(muiThemeOptions);
export default muiTheme;
